var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProtiranaVisen = function SvgProtiranaVisen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#protirana-visen_svg__a)",
    d: "M175 88a42.85 42.85 0 0 0-17-4 164 164 0 0 0-20.025 1C120.987 86.885 115 84 107 84c-1.717 0-2 1.614-2 5 0 7 9 21 18 21 12 0 56-3 56-10 0-4-2.049-10.2-4-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#protirana-visen_svg__b)",
    d: "M166.788 86c11.971 0 22.19 11.917 23.942 28.977 2.57 25.025-12.969 71.113-56.863 71.025-40.9-.082-54.867-40.05-54.867-64.03 0-21.983 17.245-37.97 27.932-37.97 15.962 0 11.972 14.988 29.928 14.988C152.946 98.988 157.81 86 166.788 86"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "protirana-visen_svg__a",
    x1: 140.002,
    x2: 140.959,
    y1: 101.39,
    y2: 70.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#409CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#77B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#A5D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#C8E2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#E2F0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#F1F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "protirana-visen_svg__b",
    x1: 79,
    x2: 191,
    y1: 135.002,
    y2: 135.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgProtiranaVisen;